'use strict';
/* eslint no-console: 0 */
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.activateByProduct = undefined;

var _apiClient = require('hub-http/clients/apiClient');

var _apiClient2 = _interopRequireDefault(_apiClient);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var activateByProduct = exports.activateByProduct = function activateByProduct(productType) {
  return _apiClient2.default.post('upgrade-catalog/v1/catalog/activation', {
    data: {
      productType: productType
    }
  });
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.1086/js/_core/common/api/activateByProduct.js
// module id = 650
// module chunks = 3 4